import apiService from '../../../apiService'
import Notification from '../../../../../../../../resources/js/notification'

export default {
  namespaced: true,
  state: {
    type: ''
  },
  mutations: {
    set (state, payload) {
      state.type = payload
    }
  },
  actions: {
    fetch ({ commit }, idParent) {
      return new Promise((resolve, reject) => {
        apiService.getType(idParent)
          .then(response => {
            commit('set', response.data.type)

            resolve(response.data)
          })
          .catch(error => {
            Notification.notifyError({
              title: 'Ошибка',
              content: 'Не удалось загрузить информацию о типе продвижения.'
            })

            reject(error)
          })
      })
    }
  }
}
